import { Fragment } from 'react'

import { toCSSPixel } from '../../../utils/styles'
import {
  getTableRowQaProps,
  TableRowActions,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../Table'

import { renderCell } from './BuildingGroupTableRow.utils'

import * as styles from './BuildingGroupTableRow.module.css'

function BuildingGroupTableRow({
  Actions = TableRowActions,
  actionLeft,
  actionsColumnWidth,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  hideCheckbox,
  isResizing,
  isSelected,
  isShort,
  item,
  resizingColumn,
  scrollRef,
  showCellBorder,
  ...restProps
}) {
  const {
    handleCallAction,
    handleClick,
    handleMouseDown,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, ...restProps })

  const { id } = item

  const qaProps = getTableRowQaProps()

  const className = useTableRowModClassName({
    className: styles.BuildingGroupTableRow,
    isSelected,
  })

  return (
    <div
      {...qaProps}
      className={className}
      key={id}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          disabled={hideCheckbox}
          selected={isSelected}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            isActive: column.name === resizingColumn,
            isResizing,
            isShort,
            item,
            name: column.name,
            scrollRef,
            showCellBorder,
            width: column.width,
          })}
        </Fragment>
      ))}
      {emptyColumnSize ? (
        <div style={{ width: toCSSPixel(emptyColumnSize) }} />
      ) : null}
      {getActions?.(item).length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default BuildingGroupTableRow
